/**
 * deeplink相关的打点
 */

export default {
  /**
    * 弹窗点击
    * @param {*} click 点击
      retry|重试
      install|安装软件
      upgrade|升级软件
      close|关闭弹窗
    * @param {*} source：来源
      video|技巧视频
      article|技巧文章
      qa|技巧问答
      other|其他活动
    * @param {*} device：设备类型
      phone|手机
      PC|电脑
    * @param {*} type：教程ID
    */
  popupClick({ click, source = 'other', device = 'pc', type }) {
    this.collect('popup_click', {
      click,
      source,
      device,
      type,
    });
  },
};
